import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import CommentPost from 'flarum/forum/components/CommentPost';
import PostComponent from 'flarum/forum/components/Post';
import SelectBestAnswerItem from './components/SelectBestAnswerItem';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import Button from 'flarum/common/components/Button';
import BestAnswerFooterPreview from './components/BestAnswerFooterPreview';
export default () => {
  extend(CommentPost.prototype, 'headerItems', function (items) {
    var _discussion$bestAnswe;
    const post = this.attrs.post;
    const discussion = post.discussion();
    if (discussion != null && discussion.hasBestAnswer() && discussion.bestAnswerPost() && ((_discussion$bestAnswe = discussion.bestAnswerPost()) == null ? void 0 : _discussion$bestAnswe.id()) === post.id() && !post.isHidden()) {
      items.add('isBestAnswer', m(SelectBestAnswerItem, {
        post: post,
        discussion: discussion
      }), -100);
    }
  });
  extend(CommentPost.prototype, 'footerItems', function (items) {
    const thisPost = this.attrs.post;
    const discussion = thisPost.discussion();
    const post = discussion.hasBestAnswer() && discussion.bestAnswerPost();
    if (post && !post.isHidden() && thisPost.number() === 1 && !thisPost.isHidden()) {
      const user = post.user();
      items.add('bestAnswerPost', m(BestAnswerFooterPreview, {
        post: post,
        user: user,
        discussion: discussion
      }), -10);
    }
  });
  extend(PostComponent.prototype, 'elementAttrs', function (elementAttrs) {
    const post = this.attrs.post;
    const discussion = post.discussion();
    if (discussion != null && discussion.hasBestAnswer() && discussion.bestAnswerPost() && discussion.bestAnswerPost().id() === post.id() && !post.isHidden()) {
      elementAttrs.className ? elementAttrs.className += ' Post--bestAnswer' : elementAttrs.className = 'Post--bestAnswer';
    }
  });
  extend(DiscussionPage.prototype, 'sidebarItems', function (items) {
    var _discussion$bestAnswe2;
    if (!app.forum.attribute('bestAnswerDiscussionSidebarJumpButton')) return;

    // @ts-ignore
    const discussion = this.discussion;
    if (discussion === null) return;
    const post = discussion.hasBestAnswer() && discussion.bestAnswerPost();
    if (post && !post.isHidden() && post.number() !== 1 && !((_discussion$bestAnswe2 = discussion.bestAnswerPost()) != null && _discussion$bestAnswe2.isHidden())) {
      items.add('jumpToBestAnswer', m(Button, {
        className: "Button Button-jumpBestAnswer",
        icon: "fas fa-check",
        onclick: () => app.current.get('stream').goToNumber(post.number()),
        "aria-label": app.translator.trans('fof-best-answer.forum.discussion.jump_to_best_answer_button')
      }, app.translator.trans('fof-best-answer.forum.discussion.jump_to_best_answer_button')), 90);
    }
  });
};